import { isValidDbId } from 'Bricks/Helpers';
import { BACKEND } from 'Services/backend';
import { createProtectTransitionKBLink } from 'app.common';

// View params getters — one per redirect destination
const incidentsRedirectParams = (params) => {
    if (isValidDbId(params?.incidentId)) {
        return `#id=INCIDENTS:id=INCIDENT_DETAILS;oid=${params.incidentId}`;
    }
    return '#id=INCIDENTS';
};

const rulesRedirectParams = (params) => {
    if (isValidDbId(params?.ruleId)) {
        // TODO: ruleId must be UUID
        return `#id=RULE_MANAGEMENT:id=RULE_DETAILS;oid=${params.ruleId}`;
    }
    return '#id=RULE_MANAGEMENT';
};

const exclusionsRedirectParams = (params) => {
    if (isValidDbId(params?.exclusionId)) {
        // TODO: exclusionId must be UUID
        return `#id=EXCLUSIONS;activeTab=iEDR_EXCLUSIONS:id=EDR_EXCLUSION_DETAILS;oid=${params.exclusionId}`;
    }
    return '#id=EXCLUSIONS;activeTab=iEDR_EXCLUSIONS';
};

const blockedHashesRedirectParams = (params) => {
    // TODO: https://jira.hq.eset.com/browse/P_EEI-27737
    // pass hashes in the URL for wizard
    // `#id=BLOCKED_HASHES:id=BLOCK_HASHES_WIZARD;
    return '#id=BLOCKED_HASHES';
};

const PROTECT_REDIRECTION_ROUTES = {
    INCIDENTS: {
        description: 'DISABLED_INCIDENTS_REDIRECTION_INFO',
        settingKey: 'showDisabledIncidentsRedirection',
        viewParams: incidentsRedirectParams,
        moreInfoLink: createProtectTransitionKBLink(),
    },
    RULES: {
        description: 'DISABLED_RULES_REDIRECTION_INFO',
        settingKey: 'showDisabledRulesRedirection',
        viewParams: rulesRedirectParams,
    },
    EXCLUSIONS: {
        description: 'DISABLED_EXCLUSIONS_REDIRECTION_INFO',
        settingKey: 'showDisabledExclusionsRedirection',
        viewParams: exclusionsRedirectParams,
    },
    BLOCKED_HASHES: {
        description: 'DISABLED_BLOCKED_HASHES_REDIRECTION_INFO',
        settingKey: 'showDisabledBlockedHashesRedirection',
        viewParams: blockedHashesRedirectParams,
    },
};

const PROTECT_REDIRECTION_USER_SETTING = 'users/settings/protectRedirection';

function redirectToProtect(viewParams, componentUuid, newTab = false) {
    const tab = newTab ? window.open('', '_blank') : window;

    if (!window.serverInfo.eraWebconsoleUrl) {
        tab.location.replace('about:blank');
        return;
    }

    BACKEND.get('oneTimeToken', componentUuid)
        .success((response) => {
            const ottParameter = response.oneTimeToken ? `?ott=${response.oneTimeToken}` : '';
            tab.location.replace(`${window.serverInfo.eraWebconsoleUrl}${ottParameter}${viewParams}`);
        })
        .failure(() => {
            tab.location.replace(`${window.serverInfo.eraWebconsoleUrl}${viewParams}`);
        })
        .execute();
}

export {
    incidentsRedirectParams,
    rulesRedirectParams,
    exclusionsRedirectParams,
    blockedHashesRedirectParams,
    PROTECT_REDIRECTION_ROUTES,
    PROTECT_REDIRECTION_USER_SETTING,
    redirectToProtect,
};
